// import { Badge, Col, Container, Row } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';

// types
import { Feature } from './types';
import { Badge, Col, Container, Row } from 'react-bootstrap';
import Capture from 'assets/images/hero/New folder/Capture.png';
import Capture1 from 'assets/images/hero/New folder/Capture1.png';
import Capture2 from 'assets/images/hero/New folder/Capture2.png';
import "./features.css";


type FeaturesProps = {
    features: Feature[];
};

const Features = ({ features }: FeaturesProps) => {
    return (
        <>
            <section className="py-5 mt-5   position-relative">
                <Container>
                    <Row className="mb-5">
                        <Col className="text-center">
                            <Badge bg="primary" pill className="mb-3 px-3 py-2">
                                Features
                            </Badge>
                            {/* <h2 className="display-6 fw-semibold">Why Choose SalesTrackify CRM?</h2> */}
                            <p className="text-muted mt-3">
                                Powerful modules that help your business grow, manage customers, and close more deals.
                            </p>
                        </Col>
                    </Row>

                    <Row className="g-4">
                        {features.map((benefit, index) => (
                            <Col lg={6} key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                                <div className="d-flex p-4 bg-white rounded shadow-sm h-100 align-items-start">
                                    <div className="me-4">
                                        <div className="d-flex align-items-center justify-content-center bg-primary bg-opacity-10 text-primary rounded-circle" style={{ width: 48, height: 48 }}>
                                            <FeatherIcon icon={benefit.icon} size={20} />
                                        </div>
                                    </div>
                                    <div>
                                        <h5 className="fw-semibold">{benefit.title}</h5>
                                        <p className="text-muted mb-0">{benefit.description}</p>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>





            {/* <section className="position-relative py-5">
                <Container>
 
                    <Row className="justify-content-center text-center mb-5">
                        <Col lg={8}>
                            <h2 className="fw-bold">
                                Performance tracking <span className="text-primary">made easy</span>
                            </h2>
                            <p className="text-muted lead mt-3">
                                Keep track of your pipelines, targets, and team performance
                            </p>
                        </Col>
                    </Row>

 
                    <div className="position-relative text-center">
                  
                        <img
                            src={Capture1}
                            alt="Sales Funnel"
                            className="position-absolute start-0 top-50 translate-middle-y shadow rounded"
                            style={{
                                width: '280px',
                                zIndex: 2,
                                transform: 'translate(-40%, -50%)'
                            }}
                        />

      
                        <img
                            src={Capture}
                            alt="Sales Dashboard"
                            className="shadow-lg rounded"
                            style={{
                                width: '650px',
                                zIndex: 1
                            }}
                        />

                   
                        <img
                            src={Capture2}
                            alt="Q1 Goals"
                            className="position-absolute end-0 top-70 translate-middle-y shadow rounded"
                            style={{
                                width: '280px',
                                zIndex: 2,
                                transform: 'translate(40%, -50%)'
                            }}
                        />
                    </div>
                </Container>
            </section> */}


            <section className="position-relative py-5">
                <Container>
                    {/* Heading */}
                    <Row className="justify-content-center text-center mb-5">
                        <Col lg={8}>
                            <h2 className="fw-bold">
                                Performance tracking <span className="text-primary">made easy</span>
                            </h2>
                            <p className="text-muted lead mt-3">
                                Keep track of your pipelines, targets, and team performance
                            </p>
                        </Col>
                    </Row>

                    {/* Dashboard Images */}
                    <div className="dashboard-images text-center position-relative">
                        {/* Left small image */}
                        <img
                            src={Capture1}
                            alt="Sales Funnel"
                            className="dashboard-img small-img left-img shadow rounded"
                        />

                        {/* Center main image */}
                        <img
                            src={Capture}
                            alt="Sales Dashboard"
                            className="dashboard-img main-img shadow-lg rounded"
                        />

                        {/* Right small image */}
                        <img
                            src={Capture2}
                            alt="Q1 Goals"
                            className="dashboard-img small-img right-img shadow rounded"
                        />
                    </div>
                </Container>
            </section>


        </>
    );
};

export default Features;
